import React from "react";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";

export default class FieldToggle extends React.Component {
  handleChange = () => {
    const {name, value} = this.props;
    this.props.onChange({name, value: !value});
  };
  render() {
    const _props = {...this.props};
    _props.onChange = this.handleChange;
    _props.checked = !!this.props.value;
    const inputStyle = {marginRight: "10px", ...this.props.inputStyle};
    const labelColor = _props.checked ? {color: "#000"} : {color: "#999"};
    const labelPlacement = _props.labelPlacement;
    const className = _props.className;
    delete _props.labelPlacement;
    delete _props.className;
    const labelStyle = {
      ...labelColor,
      ...this.props.labelStyle,
      marginLeft: "5px"
    };
    return (
      <FormGroup row>
        <FormControlLabel
          control={<Switch {..._props} color="primary" style={inputStyle} />}
          labelPlacement={labelPlacement}
          className={className}
          label={_props.label}
          style={labelStyle}
        />
      </FormGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FieldToggle/index.jsx